import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpEvent, HttpResponse, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { MeetingDetails,CaseData } from '../_models/mcst-model';
import { catchError, filter, map } from 'rxjs/operators';


@Injectable({ providedIn: 'root' })
export class PrivateService {

    constructor(private http: HttpClient) { }

    submitCaseForm(formdata: FormData): Observable<HttpEvent<{}>> {
        const req = new HttpRequest('POST', environment.apiUrl + 'api/v1/public/offices/mediation/submit-request', formdata, {
          reportProgress: true,
          responseType: 'text'
        });
        return this.http.request(req);
      }

      submitPrivateCaseForm(formdata: FormData): Observable<HttpEvent<{}>> {
        const req = new HttpRequest('POST', environment.apiUrl + 'api/v1/internal/offices/mediation/submit-request', formdata, {
          reportProgress: true,
          responseType: 'text'
        });
        return this.http.request(req);
      }

      editCaseForm(office,caseId,formdata): Observable<HttpEvent<any>> {
        const req = new HttpRequest('PUT', environment.apiUrl + 'api/v1/internal/offices/'+office+'/cases/'+caseId, formdata, {
          reportProgress: true,
          responseType: 'json'
        });
        return this.http.request(req);
      }  

    submitIndautorMeeting(formdata: FormData,type): Observable<HttpEvent<{}>> {
        const req = new HttpRequest('POST', environment.apiUrl + 'api/v1/internal/meetings/create-meeting/' + type , formdata, {
            reportProgress: true,
            responseType: 'text'
        });
        return this.http.request(req);
    }

    getMeetingDetails(officeName,caseId?): Observable<MeetingDetails[]> {
      if(caseId)
        return this.http.get<MeetingDetails[]>(environment.apiUrl  +'api/v1/internal/meetings/' + officeName +'/case/'+caseId);
      else 
        return this.http.get<MeetingDetails[]>(environment.apiUrl  +'api/v1/internal/meetings/' + officeName);
    }


    getOfficePermissionDetails(): Observable<any[]> {
        return this.http.get<any[]>(environment.apiUrl + 'api/v1/internal/offices/permissions');
    }

    getOfficeConfiguration(office): Observable<any[]> {
        return this.http.get<any[]>(environment.apiUrl + 'api/v1/public/offices/configuration?office=' + office);
    }

    getAllcases(office): Observable<any[]> {
        return this.http.get<any[]>(environment.apiUrl  +'api/v1/internal/offices/'+office+'/cases');
    }

    getCases(office,status): Observable<any[]> {
      return this.http.get<any[]>(environment.apiUrl  +'api/v1/internal/offices/'+office+'/cases?caseStatus='+status);
    }

    getAllCases(office): Observable<any[]> {
      return this.http.get<any[]>(environment.apiUrl  +'api/v1/internal/offices/'+office+'/cases?caseStatus=ACTIVE&caseStatus=CLOSED');
    }

    getAllPrecases(office): Observable<any[]> {
      return this.http.get<any[]>(environment.apiUrl  +'api/v1/internal/offices/'+office+'/cases?caseStatus=PENDING_APPROVAL&caseStatus=REJECTED');
    }

    getAllCasesDetailsWithStatus(office,status): Observable<any[]> {
      return this.http.get<any[]>(environment.apiUrl  +'api/v1/internal/offices/'+office+'/cases-with-all-data?caseStatus='+status);
    }

    getAllCasesForReports(office): Observable<any[]> { 
       return this.http.get<any[]>(environment.apiUrl  +'api/v1/internal/offices/'+office+'/cases-with-all-data?caseStatus=ACTIVE&caseStatus=CLOSED'); 
    }
    getAllPreCasesForReports(office): Observable<any[]> {
      return this.http.get<any[]>(environment.apiUrl  +'api/v1/internal/offices/'+office+'/cases-with-all-data?caseStatus=PENDING_APPROVAL&caseStatus=REJECTED');
    }

    getCaseDetails(office,id): Observable<CaseData[]> {
      return this.http.get<CaseData[]>(environment.apiUrl  +'api/v1/internal/offices/'+office+'/cases/'+id);
    }

    getCaseAllAttachmentDetails(office,id): Observable<any[]> {
      return this.http.get<any[]>(environment.apiUrl  +'api/v1/internal/offices/'+office+'/cases/'+id+'/files');
    }

    getCaseAllTemplates(office): Observable<any[]> {
      return this.http.get<any[]>(environment.apiUrl  +'api/v1/internal/offices/'+office+'/template-documents');
    }

     getAllStaff(office): Observable<any[]> {
      return this.http.get<any[]>(environment.apiUrl  +'api/v1/internal/offices/'+office+'/mediators');
    }

    updateAlias(formData: FormData): Observable<HttpEvent<{}>> {
       const req = new HttpRequest('PUT', environment.apiUrl +'api/v1/internal/offices/mediators/alias', formData, {
        reportProgress: true,
        responseType: 'text'
      });
      return this.http.request(req);
    }

    uploadTemplates(office,formData: FormData): Observable<HttpEvent<{}>> {
       return this.http.post<any>(environment.apiUrl +'api/v1/internal/offices/'+office+'/template-documents', formData, {
        reportProgress: true,
        observe: 'events'
      });
    }

    updateFile(office,templateId,formData: FormData): Observable<HttpEvent<{}>> {
      const req = new HttpRequest('PUT', environment.apiUrl +'api/v1/internal/offices/'+office+'/template-documents/'+templateId, formData, {
        reportProgress: true,
        responseType: 'text'
      });
      return this.http.request(req);
    }

    downloadAttachmentZip(office,id): Observable<HttpEvent<{Blob}>> {
      const req = new HttpRequest('POST', environment.apiUrl +'api/v1/internal/offices/'+office+'/cases/'+id+'/files/zip', {
        reportProgress: true,
        responseType: 'blob'
      });
      return this.http.request(req);
    }

    getCaseAttachmentDetails(office,id,fileId): Observable<any[]> {
      return this.http.get<any[]>(environment.apiUrl  +'api/v1/internal/offices/'+office+'/cases/'+id+'/files/'+fileId);
    }

    uploadAttachment(office,id,formData: FormData): Observable<HttpEvent<{}>> {
       return this.http.post<any>(environment.apiUrl +'api/v1/internal/offices/'+office+'/cases/'+id+'/files', formData, {
        reportProgress: true,
        observe: 'events'
      });
    }


    downloadZipFromServer(office,ID): Observable<HttpResponse<Blob>> {
    return this.http.get(environment.apiUrl +'api/v1/internal/offices/'+office+'/cases/'+ID+'/files/zip', { 
      observe: 'response', // We need the full response to get headers
      responseType: 'blob' // We expect a binary blob
    }).pipe(
      catchError((error: HttpErrorResponse) => {
        let errorMessage = 'An error occurred during file download.';
        if (error.error) {
          if (typeof error.error === 'string') {
            errorMessage = error.error;
          } else if (error.error.message) {
            errorMessage = error.error.message;
          }
        }
        // Rethrow the error to be handled by the caller
        return throwError(() => new Error(errorMessage));
      })
    );
  }

    downloadFileFromServer(office,ID,fileId): Observable<HttpResponse<Blob>> {
    return this.http.get(environment.apiUrl + 'api/v1/internal/offices/' + office + '/cases/' + ID + '/files/' + fileId, { // Make sure environment.apiUrl points to your download endpoint
      observe: 'response', // We need the full response to get headers
      responseType: 'blob' // We expect a binary blob
    }).pipe(
      catchError((error: HttpErrorResponse) => {
        let errorMessage = 'An error occurred during file download.';
        if (error.error) {
          if (typeof error.error === 'string') {
            errorMessage = error.error;
          } else if (error.error.message) {
            errorMessage = error.error.message;
          }
        }
        // Rethrow the error to be handled by the caller
        return throwError(() => new Error(errorMessage));
      })
    );
  }

    downloadTemplate(office,fileId): Observable<HttpResponse<Blob>> {
    return this.http.get(environment.apiUrl + 'api/v1/internal/offices/' + office +  '/template-documents/' + fileId, { // Make sure environment.apiUrl points to your download endpoint
      observe: 'response', // We need the full response to get headers
      responseType: 'blob' // We expect a binary blob
    }).pipe(
      catchError((error: HttpErrorResponse) => {
        let errorMessage = 'An error occurred during file download.';
        if (error.error) {
          if (typeof error.error === 'string') {
            errorMessage = error.error;
          } else if (error.error.message) {
            errorMessage = error.error.message;
          }
        }
        // Rethrow the error to be handled by the caller
        return throwError(() => new Error(errorMessage));
      })
    );
  }


  generateTemplate(office: string, fileId: string, caseId: string): Observable<HttpResponse<Blob>> {
  return this.http.post(
    environment.apiUrl + `api/v1/internal/offices/${office}/template-documents/${fileId}/generate/${caseId}`,
    null, // The request body is null or an empty object since the data is in the URL
    {
      observe: 'response',
      responseType: 'blob'
    }
  );
}

  getTemplateByID(office,templateID): Observable<any[]> {
       return this.http.get<any[]>(environment.apiUrl + 'api/v1/internal/offices/' + office +  '/template-documents/' + templateID);
  }

  deleteTemplate(office,id,templateID): Observable<HttpEvent<{}>> {
      const req = new HttpRequest('DELETE', environment.apiUrl + 'api/v1/internal/offices/' + office +  '/template-documents/' + templateID, {
        reportProgress: true,
        responseType: 'text'
      });
      return this.http.request(req);
  }

   
 deleteAttachment(office,id,fileId): Observable<HttpEvent<{}>> {
      const req = new HttpRequest('DELETE', environment.apiUrl + 'api/v1/internal/offices/' + office + '/cases/' + id + '/files/' + fileId, {
        reportProgress: true,
        responseType: 'text'
      });
      return this.http.request(req);
    }


    deleteCase(office, caseId): Observable<HttpEvent<{}>> {
      const req = new HttpRequest('DELETE', environment.apiUrl + 'api/v1/internal/offices/' + office + '/cases/' + caseId, {
        reportProgress: true,
        responseType: 'text'
      });
      return this.http.request(req);
    }

    updateCaseStatus(office,id,data:FormData): Observable<HttpEvent<{}>> {
      const req = new HttpRequest('PUT', environment.apiUrl + 'api/v1/internal/offices/'+office+'/cases/'+id+'/status', data, {
        reportProgress: true,
        responseType: 'text'
      });
      return this.http.request(req);
    }

    getOfficeAudit(office: string): Observable<any[]> {
      return this.http.get<any[]>(`${environment.apiUrl}api/v1/internal/offices/auditlog?office=${office}`);
    }


    /**
     * Searches for custom outcomes based on field criteria for a specific office
     * @param office - The office identifier
     * @param fieldName - The name of the field to search by
     * @param searchValue - The value to search for
     * @returns Observable of the HTTP response
    */

    getCustomOutcome(office: string, fieldName: string, searchValue: string): Observable<HttpEvent<string[]>> {
      let myFormData = new FormData();
      myFormData.append('fieldName', fieldName);
      myFormData.append('searchValue', searchValue);
        const req = new HttpRequest('POST', environment.apiUrl + `api/v1/internal/offices/${office}/fields/search`  , myFormData, {
            reportProgress: true,
            responseType: 'text'
        });
        // return this.http.request(req);
        return this.http.request(req).pipe(
            filter(event => event instanceof HttpResponse),
            map((event: HttpResponse<any>) => {
              // Extract the body
              const responseBody = event.body;
              // Check if it's a string that needs parsing
              if (typeof responseBody === 'string') {
                try {
                  return JSON.parse(responseBody);
                } catch (e) {
                  console.error('Error parsing response:', e);
                  return [] as string[];
                }
              }
        // If it's already parsed or null/undefined
        return responseBody || [] as string[];
        })
      );
    }

    getMediatorList(office): Observable<any[]> {
      return this.http.get<any[]>(environment.apiUrl  +'api/v1/internal/offices/'+office+'/mediators');
    }

    getCaseTitleDetails(office,caseId): Observable<any[]> {
      return this.http.get<any[]>(environment.apiUrl  +'api/v1/internal/offices/'+office+'/cases/'+caseId+'/summary');
    }

    // Quicksight Integration
    getQuicksightEmbedUrl(office: string): Observable<{ embedUrl: string }> {
      return this.http.get<{ embedUrl: string }>(environment.apiUrl + `api/v1/internal/quicksight/${office}/embed-url`);
    }
    

}


